//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  data(){
        return{
            demandNuber:0, //需求数
            projectNumber:0, //项目数
            dockingSuccess:0, //对接成功数
            mainItem:['贫困需求','项目计划','对接成功'],
            itemIndex:0,
            searchShow:false,
            searchCon:'',
            demandList:[],
            pageIndexD:1,
            pagesD:2,
            totalD:0,
            projectList:[],
            pageIndexP:1,
            pagesP:2,
            totalP:0,
            successList:[],
            pageIndexS:1,
            pagesS:2,
            totalS:0,
            statusIcon:[
              {
                status:0,
                iconImg:require('../../assets/images/socialOrgan/nojoin.png'),
              },
              {
                status:1,
                iconImg:require('../../assets/images/socialOrgan/nojoin.png'),
              },
              {
                status:2,
                iconImg:require('../../assets/images/socialOrgan/contacted.png'),
              },
              {
                status:3,
                iconImg:require('../../assets/images/socialOrgan/signed.png'),
              },
              {
                status:4,
                iconImg:require('../../assets/images/socialOrgan/launching.png'),
              },
              {
                status:5,
                iconImg:require('../../assets/images/socialOrgan/end.png'),
              }
            ],
        }
    },
    methods:{
        refresh (done) {
          setTimeout(() => {
              if(this.itemIndex == 0){
                this.pageIndexD = 1
                this.demandList = {}
                this.getDemandList();
              }else if(this.itemIndex == 1){
                this.pageIndexP = 1
                this.projectList = {}
                this.getProjectList();
              }else if(this.itemIndex == 2){
                this.pageIndexS = 1
                this.successList = {}
                this.getSuccessList();
              }
            done()
          }, 1000)
        },
        infinite (done) {
          setTimeout(() => {
              if(this.itemIndex == 0){
                if(this.pageIndexD < this.pagesD){
                  this.pageIndexD++
                  this.getDemandList();
                  done()
                }else{
                  done(true)
                }
              }else if(this.itemIndex == 1){
                if(this.pageIndexP < this.pagesP){
                  this.pageIndexP++
                  this.getProjectList();
                  done()
                }else{
                  done(true)
                }
              }else if(this.itemIndex == 2){
                if(this.pageIndexS < this.pagesS){
                  this.pageIndexS++
                  this.getSuccessList();
                  done()
                }else{
                  done(true)
                }
              }

          }, 1000)
        },
        goBack(){
            window.history.go(-1)
        },
        getMainCon(key){
            this.itemIndex = key;
            this.searchCon = '';
            if(key == 0){
              this.pageIndexD = 1;
              this.demandList = {};
              this.getDemandList();
            }else if(key == 1){
              this.pageIndexP = 1;
              this.projectList = {};
              this.getProjectList();
            }else if(key == 2){
              this.pageIndexS = 1;
              this.successList = {};
              this.getSuccessList();
            }
        },
        openSearch(){
            this.searchShow = true;
            this.searchCon = '';
        },
        closeSearch(){
            this.searchShow = false;
            this.searchCon = '';
        },
        searchList(){
            console.log(this.searchCon,this.itemIndex)
            this.searchShow = false;
            if(this.itemIndex == 0){
                this.pageIndexD = 1;
                this.demandList = {};
                this.getDemandList();
            }else if(this.itemIndex == 1){
                this.pageIndexP = 1;
                this.projectList = {};
                this.getProjectList();
            }else if(this.itemIndex == 2){
                this.pageIndexS = 1;
                this.successList = {};
                this.getSuccessList();
            }
        },
        goDetail(id){
            if(this.itemIndex == 0){
                this.$router.push({path:'/needsDetail',query:{id:id}})
            } else if(this.itemIndex == 1){
                this.$router.push({path:'/projectsDetail',query:{id:id}})
            } else if(this.itemIndex == 2){
                this.$router.push({path:'/successDetail',query:{id:id}})
            }
        },
        getTotalNum(){
            this.$https.post(this.BASE_URL+'pps/organization/findTotal',{}).then(
                res => {
                    if(res.data.code == 'PPSI0000'){
                      this.demandNuber = res.data.data.demandNuber
                      this.projectNumber=res.data.data.projectNumber
                      this.dockingSuccess=res.data.data.dockingSuccess
                    }
                }
            ).catch(err =>{
                console.log(err)
            })
        },
        getDemandList(){
            var data = {
              demandName:this.searchCon,
              pageIndex:this.pageIndexD,
              pageSize:10
            }
            this.$https.post(this.BASE_URL+'pps/organization/fpWelfareDemandList',data).then(
                res => {
//                    console.log(res)
                  if(res.data.code == 'PPSI0000'){
                      this.pagesD = res.data.data.pages;
                      this.totalD = res.data.data.total;
                      this.demandList = [...this.demandList,...res.data.data.records];
                  }
                }
            ).catch(err => {
                console.log(err)
            })
        },
        getProjectList(){
          var data = {
            projectName:this.searchCon,
            pageIndex:this.pageIndexP,
            pageSize:10
          }
          this.$https.post(this.BASE_URL+'pps/organization/fpWelfareProjectList',data).then(
            res => {
//              console.log(res)
              if(res.data.code == 'PPSI0000'){
                  this.pagesP = res.data.data.pages;
                  this.totalP = res.data.data.total;
                  this.projectList = [...this.projectList,...res.data.data.records];
              }
            }
          ).catch(err => {
            console.log(err)
          })
        },
        getSuccessList(){
          var data = {
            projectName:this.searchCon,
            pageIndex:this.pageIndexS,
            pageSize:10
          }
          this.$https.post(this.BASE_URL+'pps/organization/fpProjectSuccessList',data).then(
            res => {
//              console.log(res)
              if(res.data.code == 'PPSI0000'){
                this.pagesS = res.data.data.pages;
                this.totalS = res.data.data.total;
                this.successList = [...this.successList,...res.data.data.records];
              }
            }
          ).catch(err => {
            console.log(err)
          })
        }
    },
  mounted(){

      this.getTotalNum();
      this.getDemandList();
      this.getProjectList();
      this.getSuccessList();
  }
}



// WEBPACK FOOTER //
// ./src/crowd_fund/socialOrgan/mainList.vue